export default "__VITE_ASSET__l$Sma1Sp__"